module.exports = __webpack_public_path__ + "static/media/signage-indoor-img23.45c6f3eb.jpg";